import { useStaticQuery, graphql } from 'gatsby'

// :::: GET Article from Article title ::::
export const getStrapiBlogFromTitle = title => {
  const { blog, event, video, partner } = useStaticQuery(allStrapiBlogs)
  const list = [...blog.nodes, ...event.nodes, ...video.nodes, ...partner.nodes]
  let item = list.filter(node => node.title === title)
  return item[0] || {}
}

const allStrapiBlogs = graphql`
  query {
    blog: allStrapiBlog {
      nodes {
        title
        categories {
          name
          slug
        }
        body {
          data {
            body
          }
        }
      }
    }
    event: allStrapiEvent {
      nodes {
        title
        categories {
          name
          slug
        }
        featuredImage{
          url
        }
        body {
          data {
            body
          }
        }
      }
    }
    video: allStrapiVideo {
      nodes {
        title
        categories {
          name
          slug
        }
        body {
          data {
            body
          }
        }
      }
    }

    partner: allStrapiPartner {
      nodes {
        title
        body {
          data {
            body
          }
        }
      }
    }
  }
`
